"use strict";

define('evisions/helper',['jquery', 'underscore', 'bootstrap', 'evisions/helper/common', 'evisions/helper/array', 'evisions/helper/debug', 'evisions/helper/defer', 'evisions/helper/event', 'evisions/helper/form', 'evisions/helper/render', 'evisions/helper/spinner', 'evisions/helper/string', 'evisions/helper/test', 'evisions/styles'], function ($, _, bootstrap, EVIHelperCommon, EVIHelperArray, EVIHelperDebug, EVIHelperDefer, EVIHelperEvent, EVIHelperForm, EVIHelperRender, EVIHelperSpinner, EVIHelperString, EVIHelperTest) {
  var EVIHelper = _.extend(EVIHelperCommon, EVIHelperArray, EVIHelperDebug, EVIHelperDefer, EVIHelperEvent, EVIHelperForm, EVIHelperRender, EVIHelperSpinner, EVIHelperString, EVIHelperTest);
  $(window).on('resize', function () {
    EVIHelper.fire('window-resize', null);
  });
  $(window).on('keyup', function (ev) {
    var code = ev.which != null ? ev.which : ev.keyCode;
    EVIHelper.fire('window-keypress', code);
  });
  Function.prototype.proxy = function (obj) {
    var fn = this;
    return function () {
      return fn.apply(obj, arguments);
    };
  };
  $.event.special.enterkey = {
    delegateType: 'keypress',
    bindType: 'keypress',
    handle: function handle(event) {
      var ret,
        code = event.which != null ? event.which : event.keyCode,
        handleObj = event.handleObj,
        fn = handleObj.handler;
      if (code === 13) {
        event.type = handleObj.origType;
        ret = fn.apply(this, arguments);
        event.type = 'keypress';
      }
      return ret;
    }
  };
  return EVIHelper;
});
if (!String.prototype.trim) {
  String.prototype.trim = function () {
    return this.replace(/^\s+|\s+$/g, '');
  };
}
if (!String.prototype.ltrim) {
  String.prototype.ltrim = function () {
    return this.replace(/^\s+/, '');
  };
}
if (!String.prototype.rtrim) {
  String.prototype.rtrim = function () {
    return this.replace(/\s+$/, '');
  };
}
if (!String.prototype.fulltrim) {
  String.prototype.fulltrim = function () {
    return this.replace(/(?:(?:^|\n)\s+|\s+(?:$|\n))/g, '').replace(/\s+/g, ' ');
  };
}
;
